export const DOWNLOADFILE = (url, fileName) => {
  if (url) {
    fetch(url, {
      method: "GET",
    })
      .then((response) => response.blob())
      .then((response) => {
        const url = window.URL.createObjectURL(response);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      });
  } else {
    console.log("URL value is invalid for download to run. -" + url);
  }
};

export const isJsonEmpty = (obj) => {
  for (const prop in obj) {
    if (Object.hasOwn(obj, prop)) {
      return false;
    }
  }

  return true;
};

export const isEmailValid = (inputString) => {
  const EMAIL_PATTERN = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
  console.log(
    "EMAIL_PATTERN.test(inputString)",
    EMAIL_PATTERN.test(inputString)
  );
  return EMAIL_PATTERN.test(inputString);
};

export const isMobileNumberValid = (inputString) => {
  const MOBILE_PATTERN = /^[6-9]\d{9}$/;
  return MOBILE_PATTERN.test(inputString);
};

export const isOnlyAlphabets = (inputString) => {
  const ALPHA_PATTERN = /^[a-zA-Z\s]+$/;
  return ALPHA_PATTERN.test(inputString);
};
